import React from 'react';
import { pick, prop } from 'ramda';

import { Footer } from 'js/components/main/Footer';
import { Reconnect } from 'js/components/main/Reconnect';
import { SlideMenu } from 'js/components/main/SlideMenu';
import { WebContent } from 'js/components/system/WebContent';
import { StickyHeader } from 'js/app/components/main/StickyHeader';
import { PageRouter } from 'js/components/system/Router/components/PageRouter';
import { SideMenuLeft } from 'js/app/components/main/DefaultMenu/components/SideMenuLeft';
import { SideMenuRight } from 'js/app/components/main/DefaultMenu/components/SideMenuRight';
import { BlockForPortletsWithoutPlace } from 'js/components/system/Portlet/buzz/components/BlockForPortletsWithoutPlace';

import { useIsAdmin } from 'js/hooks/user';
import { clsx } from 'js/app/utils/clsx.util';
import { useUserSelector, useAppSelector } from '@core/js/store/hooks';
import { LOCAL_POPUP_ID } from 'js/components/common/Popup/buzz/constants';
import { useShowSideMenuLeftData } from '@interlayer/js/app/components/main/DefaultMenu/components/SideMenuLeft/hooks/useIsInDomSideMenuLeft';
import { useIsInDomSideMenuRight } from '@interlayer/js/app/components/main/DefaultMenu/components/SideMenuRight/hooks/useIsInDomSideMenuRight';

import style from './AppRouter.scss';

/**
 * Application Router that is aware about business logic.
 */
export const AppRouter = () => {
    const isAdmin = useIsAdmin();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const { showMobileMenu, showAccountMenu, applicationWCID } = useAppSelector(pick(['showMobileMenu', 'showAccountMenu', 'applicationWCID']));
    const {
        isInDom: isInDomSideMenuLeft,
        isShowed: isShowedSideMenuLeft
    } = useShowSideMenuLeftData();

    const {
        isInDom: isInDomSideMenuRight,
        isShowed: isShowedSideMenuRight
    } = useIsInDomSideMenuRight();

    const isVisibleSideMenuLeft = showMobileMenu && isShowedSideMenuLeft;
    const isVisibleSideMenuRight = showAccountMenu && isShowedSideMenuRight;

    const contentClasses = {
        [style.isShowedMenuLeft]: isVisibleSideMenuLeft,
        [style.isShowedMenuRight]: isVisibleSideMenuRight,
        isAdmin
    };

    if (applicationWCID) {
        return <WebContent id={applicationWCID} />;
    }

    return (
        <>
            <SideMenuLeft
                isInDom={isInDomSideMenuLeft}
                isVisible={isVisibleSideMenuLeft}
            />

            <div className={clsx(style.contentWrap, contentClasses)}>
                <SlideMenu />
                <StickyHeader />
                <div className={style.content}>
                    <Reconnect />
                    <PageRouter />
                    <div id={LOCAL_POPUP_ID} />
                </div>
                {isAdmin && <BlockForPortletsWithoutPlace />}
                <Footer />
            </div>

            {isLoggedIn && (
                <SideMenuRight
                    isInDom={isInDomSideMenuRight}
                    isVisible={isVisibleSideMenuRight}
                />
            )}
        </>
    );
};
